import { IPatternContainer } from "./TurnipTypes"

const PATTERNS: IPatternContainer = {
    "pattern0": {
        "mins": [
            ["", "", 0.6, 0.5, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4],
            ["", "", 0.6, 0.5, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9],
            ["", "", 0.6, 0.5, 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9],
            ["", "", 0.6, 0.5, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9],
            ["", "", 0.6, 0.5, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9],
            ["", "", 0.6, 0.5, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9, 0.9],
            ["", "", 0.6, 0.5, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4],
            ["", "", 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9],
            ["", "", 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9],
            ["", "", 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.6, 0.5, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.6, 0.5, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4],
            ["", "", 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9],
            ["", "", 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9],
            ["", "", 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.9, 0.6, 0.5, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4],
            ["", "", 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9],
            ["", "", 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9],
            ["", "", 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4],
            ["", "", 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9],
            ["", "", 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9],
            ["", "", 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.6, 0.5, 0.4],
            ["", "", 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.6, 0.5, 0.4, 0.9],
            ["", "", 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.6, 0.5, 0.4],
            ["", "", 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5],
            ["", "", 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9],
            ["", "", 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9],
            ["", "", 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9],
            ["", "", 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.9],
            ["", "", 0.6, 0.5, 0.4, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.9, 0.9],
            ["", "", 0.6, 0.5, 0.4, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5],
            ["", "", 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9],
            ["", "", 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9],
            ["", "", 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.6, 0.5, 0.4, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5],
            ["", "", 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9],
            ["", "", 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9],
            ["", "", 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5],
            ["", "", 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.6, 0.5, 0.9],
            ["", "", 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.6, 0.5, 0.9, 0.9],
            ["", "", 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.6, 0.5, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.9, 0.6, 0.5],
            ["", "", 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.6, 0.5, 0.9],
            ["", "", 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.6, 0.5, 0.9, 0.9],
            ["", "", 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.9, 0.6, 0.5],
            ["", "", 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.6, 0.5, 0.9],
            ["", "", 0.9, 0.9, 0.9, 0.9, 0.9, 0.9, 0.6, 0.5, 0.4, 0.9, 0.6, 0.5]
        ],
        "maxs": [
            ["", "", 0.8, 0.76, 1.4, 1.4, 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72],
            ["", "", 0.8, 0.76, 1.4, 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4],
            ["", "", 0.8, 0.76, 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4],
            ["", "", 0.8, 0.76, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4],
            ["", "", 0.8, 0.76, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4],
            ["", "", 0.8, 0.76, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4, 1.4],
            ["", "", 0.8, 0.76, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4, 1.4, 1.4],
            ["", "", 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72],
            ["", "", 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4],
            ["", "", 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4],
            ["", "", 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4],
            ["", "", 1.4, 0.8, 0.76, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4],
            ["", "", 1.4, 0.8, 0.76, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4, 1.4],
            ["", "", 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72],
            ["", "", 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4],
            ["", "", 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4],
            ["", "", 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4],
            ["", "", 1.4, 1.4, 0.8, 0.76, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4],
            ["", "", 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72],
            ["", "", 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4],
            ["", "", 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4],
            ["", "", 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4],
            ["", "", 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72],
            ["", "", 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4],
            ["", "", 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4],
            ["", "", 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 0.8, 0.76, 0.72],
            ["", "", 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 0.8, 0.76, 0.72, 1.4],
            ["", "", 1.4, 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 0.8, 0.76, 0.72],
            ["", "", 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76],
            ["", "", 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4],
            ["", "", 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4],
            ["", "", 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4],
            ["", "", 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 1.4],
            ["", "", 0.8, 0.76, 0.72, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 1.4, 1.4],
            ["", "", 0.8, 0.76, 0.72, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 1.4, 1.4, 1.4],
            ["", "", 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76],
            ["", "", 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4],
            ["", "", 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4],
            ["", "", 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4],
            ["", "", 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 1.4],
            ["", "", 1.4, 0.8, 0.76, 0.72, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 1.4, 1.4],
            ["", "", 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76],
            ["", "", 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4],
            ["", "", 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4],
            ["", "", 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4],
            ["", "", 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4, 1.4],
            ["", "", 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76],
            ["", "", 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 0.8, 0.76, 1.4],
            ["", "", 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 0.8, 0.76, 1.4, 1.4],
            ["", "", 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 0.8, 0.76, 1.4, 1.4, 1.4],
            ["", "", 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 1.4, 0.8, 0.76],
            ["", "", 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 0.8, 0.76, 1.4],
            ["", "", 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 0.8, 0.76, 1.4, 1.4],
            ["", "", 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 1.4, 0.8, 0.76],
            ["", "", 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 0.8, 0.76, 1.4],
            ["", "", 1.4, 1.4, 1.4, 1.4, 1.4, 1.4, 0.8, 0.76, 0.72, 1.4, 0.8, 0.76]
        ]
    },
    "pattern1": {
        "mins": [
            ["", "", 0.85, 0.9, 1.4, 2, 1.4, 0.9, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4],
            ["", "", 0.85, 0.80, 0.9, 1.4, 2, 1.4, 0.9, 0.4, 0.4, 0.4, 0.4, 0.4],
            ["", "", 0.85, 0.80, 0.75, 0.9, 1.4, 2, 1.4, 0.9, 0.4, 0.4, 0.4, 0.4],
            ["", "", 0.85, 0.80, 0.75, 0.70, 0.9, 1.4, 2, 1.4, 0.9, 0.4, 0.4, 0.4],
            ["", "", 0.85, 0.80, 0.75, 0.70, 0.65, 0.9, 1.4, 2, 1.4, 0.9, 0.4, 0.4],
            ["", "", 0.85, 0.80, 0.75, 0.70, 0.65, 0.60, 0.90, 1.4, 2, 1.4, 0.9, 0.4],
            ["", "", 0.85, 0.80, 0.75, 0.70, 0.65, 0.60, 0.55, 0.9, 1.4, 2, 1.4, 0.9]
        ],
        "maxs": [
            ["", "", 0.9, 1.4, 2, 6, 2, 1.4, 0.9, 0.9, 0.9, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.87, 1.4, 2, 6, 2, 1.4, 0.9, 0.9, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.87, 0.84, 1.4, 2, 6, 2, 1.4, 0.9, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.87, 0.84, 0.81, 1.4, 2, 6, 2, 1.4, 0.9, 0.9, 0.9],
            ["", "", 0.9, 0.87, 0.84, 0.81, 0.78, 1.4, 2, 6, 2, 1.4, 0.9, 0.9],
            ["", "", 0.9, 0.87, 0.84, 0.81, 0.78, 0.75, 1.40, 2, 6, 2, 1.4, 0.9],
            ["", "", 0.9, 0.87, 0.84, 0.81, 0.78, 0.75, 0.72, 1.4, 2, 6, 2, 1.4]
        ]
    },
    "pattern2": {
        "mins": [
            ["", "", 0.85, 0.8, 0.75, 0.70, 0.65, 0.60, 0.55, 0.50, 0.45, 0.40, 0.35, 0.30]
        ],
        "maxs": [
            ["", "", 0.9, 0.87, 0.84, 0.81, 0.78, 0.75, 0.72, 0.69, 0.66, 0.63, 0.60, 0.57]
        ]
    },
    "pattern3": {
        "mins": [
            ["", "", 0.9, 0.9, 1.4, 1.4, 1.4, 0.4, 0.35, 0.30, 0.25, 0.20, 0.15, 0.10],
            ["", "", 0.4, 0.9, 0.9, 1.4, 1.4, 1.4, 0.4, 0.35, 0.30, 0.25, 0.20, 0.15],
            ["", "", 0.4, 0.35, 0.9, 0.9, 1.4, 1.4, 1.4, 0.4, 0.35, 0.30, 0.25, 0.20],
            ["", "", 0.4, 0.35, 0.30, 0.9, 0.9, 1.4, 1.4, 1.4, 0.4, 0.35, 0.30, 0.25],
            ["", "", 0.4, 0.35, 0.30, 0.25, 0.9, 0.9, 1.4, 1.4, 1.4, 0.4, 0.35, 0.30],
            ["", "", 0.4, 0.35, 0.30, 0.25, 0.20, 0.9, 0.9, 1.4, 1.4, 1.4, 0.4, 0.35],
            ["", "", 0.4, 0.35, 0.30, 0.25, 0.20, 0.15, 0.9, 0.9, 1.4, 1.4, 1.4, 0.4],
            ["", "", 0.4, 0.35, 0.30, 0.25, 0.20, 0.15, 0.10, 0.9, 0.9, 1.4, 1.4, 1.4]
        ],
        "maxs": [
            ["", "", 1.4, 1.4, 2, 2, 2, 0.9, 0.87, 0.84, 0.81, 0.78, 0.75, 0.72],
            ["", "", 0.9, 1.4, 1.4, 2, 2, 2, 0.9, 0.87, 0.84, 0.81, 0.78, 0.75],
            ["", "", 0.9, 0.87, 1.4, 1.4, 2, 2, 2, 0.9, 0.87, 0.84, 0.81, 0.78],
            ["", "", 0.9, 0.87, 0.84, 1.4, 1.4, 2, 2, 2, 0.9, 0.87, 0.84, 0.81],
            ["", "", 0.9, 0.87, 0.84, 0.81, 1.4, 1.4, 2, 2, 2, 0.9, 0.87, 0.84],
            ["", "", 0.9, 0.87, 0.84, 0.81, 0.78, 1.4, 1.4, 2, 2, 2, 0.9, 0.87],
            ["", "", 0.9, 0.87, 0.84, 0.81, 0.78, 0.75, 1.4, 1.4, 2, 2, 2, 0.9],
            ["", "", 0.9, 0.87, 0.84, 0.81, 0.78, 0.75, 0.72, 1.4, 1.4, 2, 2, 2]
        ]
    }
}

export default PATTERNS